<template>
  <div id="ieditorreview" >
    <div class="header">
      <el-row type="flex" justify="center" align="middle" :gutter="20" style="height:100%;">
        <el-col :xs="16" :sm="16" :md="16" :lg="10" class="header-tips">
          <!-- <span class="header-tips"> -->
            <span v-if="newContent.edittime">上次保存于{{newContent.edittime}}</span>
          <!-- </span> -->
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="4">
          <span class="header-btn">
            <el-button type="info" v-on:click="reedit(newContent.id)" :disabled="filters.done" >继续编辑</el-button>
            <el-button type="success" v-on:click="releaseNews(newContent.id)" :disabled="filters.done">发布</el-button>
          </span>
        </el-col>

      </el-row>
    </div>
    <el-row type="flex" justify="center" :gutter="20">
      <el-col :xs="24" :sm="24" :md="22" :lg="14">
        <div class="review-content">
          <div class="news-box">
              <div class="box-header">
                  <span class="new-type fs-label">{{formatCategory}}</span>
                  <span class="hot-level fs-label">{{formatHotIndex}}</span>
              </div>
              <div class="box-title">
                  <h1 class="fs-title">{{newContent.title}}</h1>
              </div>
              <div class="box-author fs-label" >
                <span>{{newContent.date}}&nbsp;</span>
                <span v-if="newContent.editorname">&nbsp;编:{{newContent.editorname}}</span>
                <span v-if="newContent.hostname">&nbsp;播:{{newContent.hostname}}</span>
                <span v-else-if="newContent.host">&nbsp;播:{{newContent.host}}</span>
                <span v-if="newContent.verifiername">&nbsp;审:{{newContent.verifiername}}</span>
              </div>
              <div class="box-content">
                <el-row type="flex" justify="center" :gutter="20">
                  <el-col :xs="20" :sm="20" :md="12" :lg="10">
                  <img class="box-image" :src="newContent.cover" v-show="newContent.cover"/>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center" :gutter="20">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <p class="box-text fs-text">{{newContent.content}}</p>
                  </el-col>
                </el-row>
              </div>

              <div class="box-source fs-text" >
                <span>新闻来源:</span>
                <span>{{formatSourcefrom}}</span>
              </div>
              <div class="box-origin fs-text" >
                <span>原文地址:</span><a :href="newContent.sourceurl" target="_blank">
                <span class="link-url">{{newContent.sourceurl}}</span></a>
              </div>

              <div class="box-foot fs-label" >
                <!-- <div v-for="(lable, index) in formatLabels" :key="index">
                  <span v-if="index === 0">{{lable}}</span>
                  <span v-else>&nbsp;/ {{lable}}</span>
                </div> -->
                <span>{{formatLabels2}}</span>
              </div>
          </div>


        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    // import { markdownEditor } from 'vue-simplemde';
    import { newsType, hotsType, newsPlatform } from '../../config/config'
    import { cloneObj } from '../../utils/com.js'
    import '../../static/style/ieditor/review.scss'

    export default {
        data: function(){
            return {
                filters: {
                  done: false,
                  name: '15 Tips To Increase Your Adwords Profits',
                  content: '055型驱逐舰（英语：Type 055 destroyer，北约代号：Renhai-class [1]  ，中文名：刃海级）是中国船舶重工集团701研究所设计、江南造船厂与大连造船厂共同承建的、装备新型有源相控阵雷达的新型舰队防空驱逐舰。',
                  type: '',
                  hot: '',
                  source: '',
                  sourceurl: ''
                },
                typelist: [
                {
                  name:'娱乐',
                  id:'1'
                },
                {
                  name:'电影',
                  id:'2'
                }],
                hotlist: [
                {
                  name:'HOT 1',
                  id:'1'
                },
                {
                  name:'HOT 2',
                  id:'2'
                }],
                sourcelist: [
                {
                  name:'腾讯新闻',
                  id:'1'
                },
                {
                  name:'百度新闻',
                  id:'2'
                }],

                dynamicTags: ['标签一', '标签二', '标签三'],
                inputVisible: false,
                inputValue: '',

                // content:'12314214',
                // configs: {
                //     autofocus: true,
                //     autosave: {
                //       enabled: true,
                //       uniqueId: 'MyUniqueID20151217',
                //       delay: 6000
                //     },
                //     status: true,
                //     status: ['autosave', 'lines', 'words', 'cursor', {
                //       className: 'keystrokes',
                //       defaultValue: function(el) {
                //         this.keystrokes = 0
                //         el.innerHTML = '0 Keystrokes'
                //       },
                //       onUpdate: function(el) {
                //         el.innerHTML = ++this.keystrokes + ' Keystrokes'
                //       }
                //     }], // Another optional usage, with a custom status bar item that counts keystrokes
                //     initialValue: '',
                //     renderingConfig: {
                //         codeSyntaxHighlighting: true,
                //         highlightingTheme: 'atom-one-light'
                //     },
                //     showIcons: ['clean-block', 'horizontal-rule'],
                //     hideIcons: ['side-by-side', 'fullscreen'],
                //     shortcuts: true
                // }
            }
        },
        components: {
            // markdownEditor
        },
        computed: {
          ...mapGetters({
              // 映射 this.newContent 为 store.getters.newContent
              newContent: 'newContent',
              newsdata: 'newsdata',
          }),
          formatCategory(){
            return newsType[this.newContent.category] || '';
          },
          formatLabels(){
            return this.newContent.labels.split('#') || [];
          },
          formatLabels2(){
            return this.newContent.labels.split('#').join(' / ') || '';
          },
          formatHotIndex(){
            return hotsType[this.newContent.hotindex+''];
          },
          formatSourcefrom(){
            return this.newContent.sourcefrom || '';
            // return newsPlatform[this.newContent.sourcefrom]|| '';
          }
        },
        created() {
          console.debug("created> newContent:%o", this.newContent);
        },
        methods: {
          ...mapActions({
            // 映射 this.saveNewsContent() 为 this.$store.dispatch('saveNewsContent')
            saveNewsContent: 'saveNewsContent',
            transferNewsState: 'transferNewsState',
            updateNewsData: 'updateNewsData'
          }),
          handleTypeChange(val){
            console.debug("handleTypeChange> val:%o", val);
          },
          handleHotChange(val){
            console.debug("handleHotChange> val:%o", val);
          },
          handleUrlClick(val){
            console.debug("handleUrlClick> val:%o", val);
          },
          handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
          },

          showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
              this.$refs.saveTagInput.$refs.input.focus();
            });
          },

          handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
              this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
          },
          reedit(id){
            // location.href = './edit';
            // location.href = `./edit?id=${id}`;
            this.updateNewsDataList(this.newContent);
            this.$router.push({ path: './edit',query: { id }})
          },
          updateNewsDataList(param) {
            // console.debug('updateNewsDataList> id:%o, param:%o', param.id, param);
            if(!param || !param.id){
              return false;
            }
            let datalist = cloneObj(this.newsdata);
            // console.debug("updateNewsDataList> datalist:%o", datalist);
            let userdata = datalist.some((u,index) => {
              if (u.id === param.id ) {
                datalist[index] = param;
                // console.debug("updateNewsDataList> u:%o", u);
                return true;
              }
            });
            this.updateNewsData(datalist);
            // console.debug("updateNewsDataList> datalist:%o", datalist);
            return userdata;
          },
          releaseNews(id){
            console.debug("releaseNews> id:%o", id);
            let param = {};
            param.id = id;
            param.state = 2;
            param.tip = '';
            this.transferNewsState(param).then(
              (resp) => {
              console.debug("releaseNews> resp:%o", resp);
                if(resp.code === 0){
                    this.$message({
                        message: resp.msg,
                        type: 'success'
                    })
                    this.filters.done = true;
                    console.debug("releaseNews> done:%o", this.filters.done);
                    // this.$router.push({ path: './review',query: { id: this.newContent.id }})
                }else{
                  this.$message({
                        message: resp.msg,
                        type: 'error'
                    })
                }
              }
            );

          }


        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }

    .header{
        background: white;
        /*padding: 0 20%;*/
        height: 60px;
        border: 1px solid #939393;
        /*border-style: solid dotted dashed double;*/
        border-top: none;
        border-left: none;
        border-right: none;
        /*display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;*/
        position: fixed;
        z-index: 1;
        width: 100%;
    }
    .header .header-tips{
      /*font-size: 10px;*/
      color: #939393;
      /*width: 80%;*/
      /*border: 1px solid black;*/
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .header .header-tips .header-tips-audio{
      /*border: 1px solid blue;*/
      width: 500px;
    }
    .header .header-btn{
      /*border: 1px solid black;*/
      /*width: 150px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;*/

      /* border: 1px solid black; */
      /* width: 150px; */
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: 8px 0;

    }

    .review-content{
      /*border: 1px solid blue;*/
      margin: 0 auto;
      /*width: 60%;*/
      /*height: 600px;*/
      padding: 80px 10px;
      background: white;
    }

    .input-new-tag{
      width: 120px;
    }

    .box-author{
      font-size: 10px;
      color: #939393;
      margin-bottom: 10px;
    }

</style>



// WEBPACK FOOTER //
// review.vue?930fe24e